import Image from 'next/image';
import {useLocale, useTranslations} from 'next-intl';
import FacebookLogin from '@greatsumini/react-facebook-login';
import loginFacebook from 'src/client/methods/loginFacebook';
import SocialButton from 'src/pages/auth/SocialButton';
import {useLogin} from 'src/utils/auth/authUtils';

type Props = {
  onSignInSuccess: (user: User) => void;
  setErrorMessage: (message: string) => void;
};

export const isFacebookApp = () => {
  if (typeof navigator === 'undefined') return;

  const ua = navigator.userAgent || navigator.vendor;

  return ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1 || ua.indexOf('Instagram') > -1;
};

const FacebookLoginButton = ({onSignInSuccess, setErrorMessage}: Props) => {
  const t = useTranslations();
  const locale = useLocale();
  const {onLogin} = useLogin();

  const responseFacebook = (responseObject: any) => {
    loginFacebook(responseObject, locale)
      .then((res) => {
        onLogin(res.token, res.user);
        setTimeout(() => onSignInSuccess(res.user));
      })
      .catch((res) => {
        try {
          res.json().then((res) => {
            setErrorMessage(res.message);
          });
        } catch (err) {
          setErrorMessage(t('auth.login failed', {provider: 'Facebook'}));
        }
      });
  };

  return (
    <FacebookLogin
      appId={process.env.NEXT_PUBLIC_FACEBOOK_APP_ID}
      loginOptions={{auth_type: 'reauthenticate'}}
      dialogParams={{
        response_type: 'token',
        redirect_uri: `${process.env.NEXT_PUBLIC_PRODUCTION_APP_URL}/signin`,
        state: ''
      }}
      onSuccess={(response) => responseFacebook(response)}
      onFail={(error) => console.error('Login Failed!', error)}
      render={({onClick}) => (
        <SocialButton
          onClick={onClick}
          ProviderLogo={<Image src="/icons/facebookLogo.svg" alt="Facebook logo" width={28} height={28} />}
          text={t('auth.continue with facebook')}
        />
      )}
    />
  );
};

export default FacebookLoginButton;
